import { render, staticRenderFns } from "./card-datetime.vue?vue&type=template&id=cdda63b6"
import script from "./card-datetime.vue?vue&type=script&lang=js"
export * from "./card-datetime.vue?vue&type=script&lang=js"
import style0 from "./card-datetime.vue?vue&type=style&index=0&id=cdda63b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports